import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import React__default from 'react';
import AutoplayButtonModuleCss from './index.module.css.js';
import { useAutoplay } from '../../modules/Autoplay.js';
import { IntervalState } from '../../modules/IntervalTimer.js';
import { composeCssClasses } from '../../utils/composeCssClasses.js';
var ButtonType;

(function (ButtonType) {
  ButtonType["PLAY"] = "play";
  ButtonType["PAUSE"] = "pause";
})(ButtonType || (ButtonType = {}));

var AutoplaySvg = /*#__PURE__*/function () {
  function AutoplaySvg() {
    _classCallCheck(this, AutoplaySvg);
  }

  _createClass(AutoplaySvg, null, [{
    key: "getPath",
    value: function getPath(buttonType) {
      if (buttonType === ButtonType.PAUSE) return AutoplaySvg.pausePath;else return AutoplaySvg.playPath;
    }
  }]);

  return AutoplaySvg;
}();

AutoplaySvg.playPath = 'M 12,26 18.5,22 18.5,14 12,10 z M 18.5,22 25,18 25,18 18.5,14 z';
AutoplaySvg.pausePath = 'M 12,26 16,26 16,10 12,10 z M 21,26 25,26 25,10 21,10 z';

function AutoplayButton(props) {
  var className = props.className,
      style = props.style,
      _props$position = props.position,
      position = _props$position === void 0 ? {
    bottom: '0',
    left: '0'
  } : _props$position;

  var _useAutoplay = useAutoplay(),
      isPausedByUser = _useAutoplay.state.isPausedByUser,
      autoplayState = _useAutoplay.autoplayState,
      resume = _useAutoplay.resume,
      pause = _useAutoplay.pause;

  var _React__default$useSt = React__default.useState(autoplayState !== IntervalState.IDLE ? ButtonType.PAUSE : ButtonType.PLAY),
      _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
      buttonType = _React__default$useSt2[0],
      setButtonType = _React__default$useSt2[1];

  var onClickHandler = function onClickHandler(event) {
    event.stopPropagation();
    if (isPausedByUser) resume();else pause();
  };

  React__default.useEffect(function () {
    if (isPausedByUser && autoplayState === IntervalState.IDLE) setButtonType(ButtonType.PLAY);else if (isPausedByUser && autoplayState === IntervalState.PAUSED) setButtonType(ButtonType.PLAY);else setButtonType(ButtonType.PAUSE);
  }, [isPausedByUser, autoplayState]);
  return React__default.createElement("button", {
    className: composeCssClasses('hero-slider-autoplay-button', AutoplayButtonModuleCss.Button, className),
    onClick: onClickHandler,
    style: Object.assign(Object.assign({}, position), style)
  }, React__default.createElement("svg", {
    fill: "currentColor",
    height: "100%",
    width: "100%",
    viewBox: "0 0 36 36"
  }, React__default.createElement("path", {
    d: AutoplaySvg.getPath(buttonType)
  })));
}

AutoplayButton.displayName = 'hero-slider/autoplay-button';
export { AutoplayButton };